import { EnumOption } from './enum-option';
import { createEnumOptions } from '../../shared/utils';

export enum ActionMode {
  None = 0,
  Prompt = 1,
  Background = 2,
}

export const ActionModeList: EnumOption[] = createEnumOptions(ActionMode);
